var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkBenefitRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 226,
    viewBox: "0 0 176 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.575.16c-56.818 1.107-115.17 15.87-158.578 58.967-27.76 27.446-46.697 62.444-54.418 100.57-7.714-38.129-26.652-73.129-54.417-100.57C125.749 18.011 70.117 1.503 16.286.104c-2.54 0-5.08-.097-7.605-.097H.002v24.831c0 3.268.07 6.537.238 9.805 2.33 47.986 21.697 96.345 58.1 132.477 38.567 38.278 112.575 57.583 163.114 57.887h.195c50.636-.304 124.532-19.596 163.127-57.901 37.241-36.949 56.636-86.72 58.226-135.718V.16h-8.427zM68.596 153.45c.14 0 0 0 0 0z",
    fill: "#F7F3FF"
  })));
}
export default SvgWorkBenefitRight;